var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRowColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 15.821,
    viewBox: "0 0 16 15.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5096",
    "data-name": "Rectangle 5096",
    width: 16,
    height: 15.821,
    fill: "#2a2a2a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Row_Color_Icon",
    "data-name": "Row Color Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M22.627,17.915a.281.281,0,0,0-.442,0c-.478.6-1.569,2.048-1.569,2.863a1.79,1.79,0,1,0,3.579,0c0-.815-1.09-2.265-1.569-2.863",
    transform: "translate(-8.196 -7.079)",
    fill: "#cc004a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M8.407.662l-.584.584L7.595.49a.688.688,0,1,0-1.318.4L6.718,2.35,0,9.069l6.753,6.753L15.16,7.414ZM2.512,8.5,7.17,3.846l.395,1.307a.689.689,0,0,0,1.318-.4L8.275,2.741l.132-.132,4.805,4.8L12.024,8.6Z",
    transform: "translate(0 0)",
    fill: "#050605"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowColor);
export default __webpack_public_path__ + "static/media/rowColor.d25bfce1c5798f426f3f8dbe5d2c4513.svg";
export { ForwardRef as ReactComponent };